<template>
  <div>
    <app-header />
    <div class="swiper-box" @mousewheel="rollScroll" style="float: left;width: 100%;height: 100vh;">
      <el-carousel sty height="100vh" trigger="click" :loop="false" direction="vertical" :autoplay="false" ref="carousel">
        <el-carousel-item key="1">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyim.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1380px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 448px;height: 148px;font-size: 56px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 74px;float: left;margin-top: 260px;">吾征智慧康养系统</div>
              <img src="@/assets/images/cardiobrain/diyiimgre.png" alt="" style="width: 832px;height:750px;float: right;margin-top: 128px;" class="donghua">
              <div style="width: 300px;height: 72px;font-size: 24px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 36px;float: left;margin-top: 40px;margin-right: 100px;">筛查、监护、预警、救援 <br>一体化的康养服务</div>
              <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #036BF7;border-radius: 30px;font-size: 16px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 50px;text-align: center;float: left;margin-top: 100px;cursor: pointer;" @click="cl = true">点击获取报价>></div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">INTELLIGENT HEALTH CARE SYSTEM</div>
              <!--     <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">技术优势</div>
                <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 100px;text-align: center;">心脑监测预警手表+AI认知算法+APP+数据管理平台+数字大屏<br>
                  构建吾征AI心脑血管疾病风险评估与筛查系统</div>
              </div> -->
              <div style="width: 100%;float: left;margin-top: 300px;">
                <div style="width:880px;height: 480px;background: linear-gradient(90deg, #0D76FF 0%, rgba(102,168,255,0) 100%);border-radius: 20px;float: left;margin-left: 0;padding: 0 28px;box-sizing: border-box;" class="donghua">
                  <div style="width: 440px;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;margin-top: 90px;margin-left: 70px;">吾征智慧康养系统</div>
                  <div style="width: 440px;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;margin-top: 40px;margin-left: 70px;">集成AI算法引擎、IOT平台、可穿戴生理监测设备、居家物联网设备、云台音视频设备及云服务等技术为一体的康养平台。
                    <br> <br>
                    实现对人体医学生物特征认知识别计算、疾病风险精准评估、异常状态实时监测预测、危险情况精准预警和全时全域120救援服务、照护过程留痕等功能。
                    <br> <br>
                    适用于社区居家康养、康养平台、集中康养机构及旅居等康养领域，帮助康养机构建立标准化流程、提升管理效率、塑造品牌公信度。
                  </div> <br>
                  <img src="@/assets/images/cardiobrain/tuyi.png" alt="" style="width: 648px;height:584px;float: right;float: right;margin-top: -227px;margin-right: -411px;">
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="3">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">技术优势</div>
                <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 40px;text-align: center;">基于“智能+健康+救护”模式的核心技术优势</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 80px;">
                <div style="width: 300px;float: left;">
                  <div :class="li==1?'donghua1 into':'into'" class="into" @click="li=1" :style="{opacity:li==1?1:0.3}">
                    <span>“智能+健康+救护” <br>模式助力康养行业服务升级</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">1</span>
                  </div>
                  <div :class="li==2?'donghua1 into':'into'" @click="li=2" :style="{opacity:li==2?1:0.3,margin:'10px 0'}">
                    <span>高精度的算法模型，<br>让康养服务有迹可循</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">2</span>
                  </div>
                  <div :class="li==3?'donghua1 into':'into'" @click="li=3" :style="{opacity:li==3?1:0.3}">
                    <span>全时全域全方位救护，<br>一体化解决方案</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">3</span>
                  </div>
                </div>
                <div class="libox">
                  <div v-if="li==1" :class="li==1?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;margin-bottom: 30px;">“智能+健康+救护”模式助力康养行业服务升级</div>
                    <div>传统的康养服务依然重在管理，缺失真正的健康理念，吾征AI智慧康养系统区别于传统的康养服务，以“智能+健康+救护”为核心，真正把老人健康放心上，助力康养行业服务升级。</div>
                  </div>
                  <div v-if="li==2" :class="li==2?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;margin-bottom: 30px;">高精度的算法模型，让康养服务有迹可循</div>
                    <div>7年大数据分析+语义认知算法技术加持，提供高标准认知计算；
                      <br><br>
                      心脑多疾病风险评估与筛查模型；
                      <br><br>
                      心脑精准预警模型：通过身体异常信号识别模型提供多维度认知分析及解决方案，应用人工智能深度学习技术，针对不同“个人”智能化制定预警方案，通过身体异常信号识别模型提供多维度认知分析及解决方案。</div>
                  </div>
                  <div v-if="li==3" :class="li==3?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;text-align: center;margin-bottom: 60px;width: 100%;float: left;margin-top: 20px;">全时全域全方位救护，一体化解决方案</div>
                    <div style="width: 170px;height: 200px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left; padding: 6px;box-sizing: border-box;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">300+</div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;">全国300多个核心城市的340多家急救中心</div>
                    </div>
                    <div style="width: 170px;height: 200px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">1000+</div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;">上千家网络医院</div>
                    </div>
                    <div style="width: 170px;height: 200px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">230</div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;">全球230个国家和地区的救援服务网络</div>
                    </div>
                    <div style="width: 170px;height: 200px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">250+</div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;">全国权威医院近250位专家的优质健康服务资源</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="4">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(130deg, #387AEE 0%, #66A8FF 100%);"></div>
            <img src="@/assets/images/cardiobrain/bolang.png" alt="" style="width: 100%;height:228px;position: absolute;z-index: 0;left: 0;bottom: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color:rgba(255, 255, 255, 0.1);line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;">OUR SERVICE</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;">我们的服务</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 160px;">
                <div style="width: 220px;height: 360px;background: #A1C2F9;border-radius: 10px;float: left;margin-right: 25px;" class="donghua">
                  <div style="width: 220px;height: 350px;background: #fff;border-radius: 10px;float: left;padding: 40px 28px;box-sizing: border-box;">
                    <img src="@/assets/images/cardiobrain/cdfj1.png" alt="" style="width: 94px;height:80px;float: left;margin-left: 41px;">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;width: 100%;float: left;text-align: center;margin-top: 20px;margin-bottom: 10px;">筛查</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;">
                      · 脑卒中 <br> · 脑卒中复发 <br> · 房颤脑卒中 <br>· 冠心病 <br>· 动脉硬化性心血管疾病等
                    </div>
                  </div>
                </div>
                <div style="width: 220px;height: 360px;background: #A1C2F9;border-radius: 10px;float: left;margin-right: 25px;margin-top: 40px;" class="donghua">
                  <div style="width: 220px;height: 350px;background: #fff;border-radius: 10px;float: left;padding: 40px 28px;box-sizing: border-box;">
                    <img src="@/assets/images/cardiobrain/cdfj2.png" alt="" style="width: 94px;height:80px;float: left;margin-left: 41px;">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;width: 100%;float: left;text-align: center;margin-top: 20px;margin-bottom: 10px;">预警</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;">· 个性化智能预警<br>· sos预警<br>· 跌倒预警<br>· 围栏预警
                    </div>
                  </div>
                </div>
                <div style="width: 220px;height: 360px;background: #A1C2F9;border-radius: 10px;float: left;margin-right: 25px;" class="donghua">
                  <div style="width: 220px;height: 350px;background: #fff;border-radius: 10px;float: left;padding: 40px 28px;box-sizing: border-box;">
                    <img src="@/assets/images/cardiobrain/cdfj3.png" alt="" style="width: 94px;height:80px;float: left;margin-left: 41px;">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;width: 100%;float: left;text-align: center;margin-top: 20px;margin-bottom: 10px;">全国救援</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;">
                      · 全国全时120救援<br>
                      · 电话医疗急救指导<br>
                      · 协助安排住院<br>
                      · 紧急信息通报<br>
                      · 住院费用担保/垫付<br>
                      · 病情跟踪与医疗监控<br>
                      · 医疗单据收集
                    </div>
                  </div>
                </div>
                <div style="width: 220px;height: 360px;background: #A1C2F9;border-radius: 10px;float: left;margin-right: 25px;margin-top: 40px;" class="donghua">
                  <div style="width: 220px;height: 350px;background: #fff;border-radius: 10px;float: left;padding: 40px 28px;box-sizing: border-box;">
                    <img src="@/assets/images/cardiobrain/cdfj4.png" alt="" style="width: 94px;height:80px;float: left;margin-left: 41px;">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;width: 100%;float: left;text-align: center;margin-top: 20px;margin-bottom: 10px;">照护服务</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;">
                      · 照护计划制定<br>
                      · 照护管理<br>
                      · 照护台账管理
                    </div>
                  </div>
                </div>
                <div style="width: 220px;height: 360px;background: #A1C2F9;border-radius: 10px;float: left;" class="donghua">
                  <div style="width: 220px;height: 350px;background: #fff;border-radius: 10px;float: left;padding: 40px 28px;box-sizing: border-box;">
                    <img src="@/assets/images/cardiobrain/cdfj5.png" alt="" style="width: 94px;height:80px;float: left;margin-left: 41px;">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;width: 100%;float: left;text-align: center;margin-top: 20px;margin-bottom: 10px;">空间与环境管理</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;">
                      · 室内温湿度与病菌致病风险<br>
                      智能预警<br>
                      · 楼栋和区域、楼层和区域、
                      房间和区域、床位和位置等
                      监控管理
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="5">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #F6FAFF;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;">ONE-STOP SERVICE</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">一条龙服务</div>
                <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 30px;text-align: center;">（筛查、监护、预警、救援）</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 30px;">
                <img src="@/assets/images/cardiobrain/zuot.png" alt="" style="width: 668px;height:558px;float: left;" class="donghua">
                <div style="width:530px;float: left;margin-top: 34px;">
                  <div style="width: 100%;height: 150px;background: linear-gradient(90deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;padding: 30px;box-sizing: border-box;" class="donghua">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;margin-bottom: 16px;">筛查与初筛定级</div>
                    <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">基于心脑多疾病筛查和风险分析模型对居民心脑血管疾病发病风险进行初筛和评估，并形成初筛定级报告，将居民分成高危、中危、低危和正常四个风险等级。</div>
                  </div>
                  <div style="width: 100%;height: 150px;background: linear-gradient(90deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;padding: 30px;box-sizing: border-box;margin: 20px 0;" class="donghua">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;margin-bottom: 16px;">监测预警</div>
                    <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">应用人工智能深度学习技术，针对不同“个人”智能化制定预警方案，通过身体异常信号识别模型提供多维度认知分析及解决方案。</div>
                  </div>
                  <div style="width: 100%;height: 150px;background: linear-gradient(90deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;padding: 30px;box-sizing: border-box;" class="donghua">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;margin-bottom: 16px;">全国全时医学救援</div>
                    <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">目前已拥有覆盖全国300多个核心城市的340多家急救中心，为居民建立一条专业、便捷的无障碍健康与安全服务绿色通道。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="6">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">SPACE AND ENVIRONMENT</div>
              <div style="width: 100%;float: left;margin-top: 150px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">空间与环境管理</div>
                <!--  <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 30px;text-align: center;">（筛查、监护、预警、救援）</div> -->
              </div>
              <div style="width: 100%;float: left;margin-top: 30px;">
                <img src="@/assets/images/cardiobrain/kaiyi.png" alt="" style="width: 620px;height:342px;float: left;" class="donghua">
                <div style="width: 560px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;float: left;margin-top: 80px;">
                  <span style="display: block;">环境与疾病AI预警</span>
                  <span style="width: 100px;height: 6px;background: #0D76FF;display: block;margin-top: 10px;"></span>
                </div>
                <div style="width: 560px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;float: left;">
                  自动推导、预测出普通疾病的风险指数以及致病病菌生长、繁殖风险，指导家人控制好室内温湿度，避免病菌的入侵和预防可能的疾病。
                  利用智能识别引擎对室内外温湿度监测信息、数值数据进行高精度算法处理分析，并推导出包括室内病菌危险指数、心脏病事件发作指数、流感杆菌感染指数、呼吸道疾病发病指数及沙门氏菌感染指数在内的60多种病菌致病指数分析。
                </div>
                <div style="clear: both;"></div>
                <div style="width: 560px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;float: left;margin-top: 80px;">
                  <span style="display: block;">空间音、视频监控</span>
                  <span style="width: 100px;height: 6px;background: #0D76FF;display: block;margin-top: 10px;"></span>
                  <div style="width: 560px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;margin-top: 20px;float: left;">
                    对接完成后可在任何时间任何地点打开网页或手机APP实时查看场所音视频直播，实现实时语音交互。当系统发现风险报警时，会自动抓拍3-5张照片，工作人员也可通过云台监控的音视频交互了解被照护人当下情况。满足管理者、被照护人、被照护人家属的真实需求。
                  </div>
                </div>
                <img src="@/assets/images/cardiobrain/kaiyi1.png" alt="" style="width: 620px;height:342px;float: left;" class="donghua">
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="7">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #F6FAFF;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">APPLICATION SIDE COMPOSITION</div>
              <div style="width: 100%;float: left;margin-top: 150px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">应用端构成</div>
                <!--  <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 30px;text-align: center;">（筛查、监护、预警、救援）</div> -->
              </div>
              <div style="width: 100%;float: left;margin-top: 30px;">
                <div style="width: 100%;float: left;border-bottom: 2px solid rgba(13, 118, 255, 0.1);">
                  <div style="width: 50%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;cursor: pointer;">
                    <span class="inli" :style="{borderBottom: inli==1?'2px solid  #0D76FF':'2px solid  rgba(13, 118, 255, 0)',color:inli==1?'#0D76FF':'#000000'}" @click="inli=1">康养机构管理 PC端</span>
                  </div>
                  <div style="width: 50%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;cursor: pointer;">
                    <span style="width: 220px;display: inline-block;padding-bottom: 20px;box-sizing: border-box;text-align: center;border-bottom: 2px solid  #0D76FF;" class="inli" :style="{borderBottom: inli==2?'2px solid  #0D76FF':'2px solid  rgba(13, 118, 255, 0)',color:inli==2?'#0D76FF':'#000000'}" @click="inli=2">服务及监护工具 APP端</span></div>
                </div>
                <img src="@/assets/images/cardiobrain/yingyong.png" alt="" style="width: 100%;height:410px;float: left;margin-top: 60px;" v-if="inli==1" :class="inli==1?'donghua1 donghua':'donghua'">
                <img src="@/assets/images/cardiobrain/yingyong1.png" alt="" style="width: 100%;height:536px;float: left;margin-top: 60px;" v-if="inli==2" :class="inli==2?'donghua1 donghua':'donghua'">
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="8">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">APPLICATION SCENARIOS</div>
              <div style="width: 100%;float: left;margin-top: 150px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">应用场景</div>
                <!--  <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 30px;text-align: center;">（筛查、监护、预警、救援）</div> -->
              </div>
              <div style="width: 100%;float: left;margin-top: 30px;">
                <div class="tuingo1 tuingo donghua">
                  <div style="width: 100%;height: 100%;background: rgba(13, 118, 255, 0.8);border-radius: 10px;padding: 30px 40px;box-sizing: border-box;">
                    <div style="text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">康养机构</div>
                    <div style="margin-top: 20px;">通过信息化运营管理平台各角色间的信息交互，形成一套完整的智能化的科学养老管理体系，助力康养服务机构优化照护体验，简化医护工作流程，提升工作效率。</div>
                  </div>
                </div>
                <div class="tuingo2 tuingo donghua">
                  <div style="width: 100%;height: 100%;background: rgba(13, 118, 255, 0.8);border-radius: 10px;padding: 30px 40px;box-sizing: border-box;">
                    <div style="text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">社区养老、集中养老</div>
                    <div style="margin-top: 20px;">系统提供全面的智能康养服务，从筛查、监护、预警到120救援实现全线智能化，用最少的人工和精力实现一对多的看护模式。</div>
                  </div>
                </div>
                <div class="tuingo3 tuingo donghua">
                  <div style="width: 100%;height: 100%;background: rgba(13, 118, 255, 0.8);border-radius: 10px;padding: 30px 40px;box-sizing: border-box;">
                    <div style="text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">旅居养老机构</div>
                    <div style="margin-top: 20px;">突破空间、床位、服务及产品等传统禁锢，以健康管理、照护服务、个性化定制等为核心服务，实现管理系统与硬件联动，更多智能场景交互，实现“1+N+N”数字化康养新模式升级，即1个康养中心，服务N座城市千家万户，最终实现“从容纳千百人的康养，转变为联接城市千家万户的智慧康养”。</div>
                  </div>
                </div>
                <div class="tuingo4 tuingo donghua">
                  <div style="width: 100%;height: 100%;background: rgba(13, 118, 255, 0.8);border-radius: 10px;padding: 30px 40px;box-sizing: border-box;">
                    <div style="text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">个人养老</div>
                    <div style="margin-top: 20px;">智慧养老系统(包含人体感应、门磁、紧急按钮、智能生命体征监测仪等硬件设备,以及物联网软件平台),对老人居家时走动情况和进出门情况进行感知、监护，实现独居时安全自动值守,突发情况时第一时间通过系统和中控台系统通知监护人及护工，解决独居老人的健康及安全问题。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="9">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(130deg, #387AEE 0%, #66A8FF 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;opacity: 0.1;">LEARN MORE</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;">了解更多</div>
                <div style="width: 100%;float: left;margin-top: 200px;">
                  <!--          <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 0;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">更多文章</div>
                      <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 22px;margin-top: 30px; text-decoration: underline; ">◆ 吾征推出心脑血管AI健康管理计划，赋能社区居民美好生活<br><br> ◆ 后疫情时代需要监测吗？这些人真需要！<br><br> ◆ 推动心脑血管疾病防治工程建设，助力心脑辅助诊疗迈上新台阶。</div>
                    </div>
                  </div> -->
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 180px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">资料下载</div>
                         <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 60px;text-align: center;margin-left:70px ;margin-top: 74px;"> <a class="aquchu" href="https://ftp.infobigdata.com/smartHealthCareProductInformation.pdf" target="_blank">点击下载资料</a> </div>
                    </div>
                  </div>
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 100px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">获取报价</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;margin-left:70px ;margin-top: 74px;padding: 10px 0;box-sizing: border-box;cursor: pointer;" @click="cl = true">点击获取<br>详细方案及报价</div>
                    </div>
                  </div>
                  <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 19px;text-align: center;margin-top: 160px;">© Copyright © 2017-2021 中润普达 - 京ICP备2021002262号-1</div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
        <!-- <app-footer /> -->
    <div style="width: 100%;height: 100vh;position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;z-index: 999;
    background: rgba(0, 0, 0, 0.8);" v-if="cl" @click="cl = false">
      <img src="@/assets/images/cardiobrain/erweima.jpg" alt="" style="width: 10vw;height: 10vw;margin:0 45vw;margin-top:30vh;">
      <div style="width: 100%;text-align: center;font-size: 16px;color: #fff;margin-top: 10px;">扫码添加获取详细方案及报价</div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'

export default {
  data() {
    return {
      cl: false,
      inli: 1,
      li: 1,
      zoucl: true,
      scrollBox: { time: 300 },

    }
  },
  mounted() {


  },
  methods: {
    zouni() {
      var myVideo = document.getElementById("video");
      if (myVideo.paused) {
        myVideo.play();
        this.zoucl = false;
      } else {
        myVideo.pause();
        this.zoucl = true;

      }

    },
    rollScroll(event) {
      console.log(event)
      let _that = this;
      let scrollVal = event.wheelDelta || event.detail;
      if (_that.scrollBox.time) {
        clearTimeout(_that.scrollBox.time)
      }
      _that.scrollBox.time = setTimeout(() => {
        scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next();
      }, 300);
    },
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}

</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.swiper-box .el-carousel__indicator--vertical .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #C6E0FF;
  border: none;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0);

}

.swiper-box .el-carousel__indicator.is-active button {
  background-color: #0D76FF;
  border: 2px solid #C6E0FF;
}

.libox {
  width: 890px;
  height: 500px;
  overflow: hidden;
  float: left;
  padding: 80px 76px;
  box-sizing: border-box;
  margin-left: 10px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 22px;
  background: url(../assets/images/cardiobrain/beij.png) 0 0 no-repeat;
}

.into {
  width: 100%;
  height: 160px;
  background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);
  border-radius: 4px;
  float: left;
  padding: 56px 30px;
  box-sizing: border-box;
  position: relative;
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #FFFFFF;
  cursor: pointer;
}

.inli {
  width: 220px;
  display: inline-block;
  padding-bottom: 20px;
  box-sizing: border-box;
  text-align: center;
}

.tuingo {
  width: 570px;
  height: 300px;
  float: left;
  padding: 45px;
  box-sizing: border-box;
  margin-bottom: 60px;
  color: #fff;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
   cursor: pointer;


}

.tuingo1 {
  background: url(../assets/images/cardiobrain/cjin1.png) 0 0 no-repeat;
  margin-right: 60px;

}

.tuingo2 {
  background: url(../assets/images/cardiobrain/cjin2.png) 0 0 no-repeat;

}

.tuingo3 {
  background: url(../assets/images/cardiobrain/cjin3.png) 0 0 no-repeat;
  margin-right: 60px;

}

.tuingo4 {
  background: url(../assets/images/cardiobrain/cjin4.png) 0 0 no-repeat;

}

.donghua {
  -webkit-transition: -webkit-transform 1s ease;
  /* For Safari 3.1 to 6.0 */
  transition: transform 1s ease;
}

.donghua:hover {
  -ms-transform: scale(1.1);
  /* IE 9 */
  -webkit-transform: scale(1.1);
  /* Safari */
  transform: scale(1.1);
  /* 标准语法 */
}
.donghua1{
  animation:myfirst 2s;
  -webkit-animation:myfirst 2s; /* Safari and Chrome */
}

@keyframes myfirst
{
  from {opacity:0;}
  to {opacity:1;}
}

@-webkit-keyframes myfirst /* Safari and Chrome */
{
  from {opacity:0;}
  to {opacity:1;}
}
.aquchu {
  text-decoration: none;
  color: #fff;
}

.aquchu:hover,
.aquchu:visited,
.aquchu:link,
.aquchu:active {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/retirement.vue